import React from 'react';
import { LoadingContainer, Spinner, LoadingText } from './styles';

interface LoaderProps {
  text?: string;
  size?: 'sm' | 'md' | 'lg';
}

const Loader: React.FC<LoaderProps> = ({ text = 'Carregando...', size = 'md' }) => (
  <LoadingContainer role="status" aria-live="polite" aria-label={text}>
    <Spinner size={size} />
    <LoadingText>{text}</LoadingText>
  </LoadingContainer>
);

export default Loader;
